import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { getFormattedDuration } from '@fec/assets/js/utils/media-progress';
import { formatDate } from '@fec/assets/js/utils/date-time-formatter';

import './BasicCaption.scss';

const BasicCaption = ({
  asset,
  isActive,
  fillContainer,
  showRuntime = true,
}) => {
  const { type, title, show, date, image, imageCopyright, duration } = asset;
  const { source, imageSourceLink } = image;
  const { t } = useTranslation();

  const getDescription = () => {
    if (type === 'video' || !showRuntime) {
      return t('basicCaption.videoCaption', {
        show: `<b>${show}</b>`,
        date: formatDate(date),
      });
    } else {
      return t('basicCaption.audioCaption', {
        runTime: `${getFormattedDuration(duration)} min`,
        show: `<b>${show}</b>`,
        date: formatDate(date),
      });
    }
  };

  const sourceToDisplay = source ?? imageCopyright;

  const description = getDescription();

  if (!title && !description && !sourceToDisplay) {
    return null;
  }

  return (
    <div
      className={classNames('basic-caption', {
        'basic-caption--active': isActive,
        'basic-caption--fill-container': fillContainer,
      })}>
      {title && <div className="basic-caption__title">{title}</div>}
      {description && (
        <div
          className="basic-caption__description"
          dangerouslySetInnerHTML={{ __html: description }}></div>
      )}
      {sourceToDisplay && (
        <>
          {imageSourceLink ? (
            <a
              href={imageSourceLink}
              className="basic-caption__image-source-link"
              rel="nofollow noreferrer"
              target="_blank"
              data-app-image-source="">
              {t('basicCaption.imageSource', { source: sourceToDisplay })}
            </a>
          ) : (
            <div
              className="basic-caption__image-source"
              data-app-image-source="">
              {t('basicCaption.imageSource', { source: sourceToDisplay })}
            </div>
          )}
        </>
      )}
    </div>
  );
};

BasicCaption.propTypes = {
  asset: PropTypes.object,
  isActive: PropTypes.bool,
  fillContainer: PropTypes.bool,
  showRuntime: PropTypes.bool,
};

export default BasicCaption;
